import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames'

import FileItem from '../FileItem/dndContainer'


class DropField extends PureComponent {
  render() {
    const { label, connectDropTarget, isOver, unsetField } = this.props;

    return connectDropTarget(
      <div className={cn("gs-import__drop-item", {_empty: !label, _over: isOver})}>
        {label && <FileItem label={label} unsetField={() => unsetField(label)}/>}
        {!label && <div className="gs-import__value"><span className="gs-text _sm _dim">Empty</span></div> }
      </div>
    );
  }
}

DropField.propTypes = {
  label: PropTypes.string,
  connectDropTarget: PropTypes.func.isRequired,
  unsetField: PropTypes.func.isRequired,
  setField: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired
};

export default DropField;
